<div class="grid-container mat-elevation-z10">
    <div class="" fxLayout="row" fxLayoutAlign="space-between" style="padding: 10px 30px 30px">
      <h3>Report Soste {{ data.mezzo }} </h3>
    </div>
    <div class="" style="overflow-x: auto">
      <!--(matSortChange)="onTableClicked(data)" (matSortChange)="sortData($event)" row.delivery_category_item.type.tipologia {{getCellValue(row, column) }}-->
      <table mat-table [dataSource]="data.fermate"  aria-describedby="conferrals tables">
        <ng-container matColumnDef="inizio_fermata">
            <th mat-header-cell *matHeaderCellDef>
              {{ "custom-report2.grid.column.inizio_fermata" | translate }}
            </th>
            <td mat-cell *matCellDef="let row">
              {{ row.inizio_fermata | date:'dd/MM/yyyy, HH:mm:ss'  }}
            </td>
        </ng-container>
        <ng-container matColumnDef="fine_fermata">
            <th mat-header-cell *matHeaderCellDef>
              {{ "custom-report2.grid.column.fine_fermata"  | translate }}
            </th>
            <td mat-cell *matCellDef="let row">
              {{ row.fine_fermata | date:'dd/MM/yyyy, HH:mm:ss'  }}
            </td>
        </ng-container>
        <ng-container matColumnDef="minuti_fermata">
          <th mat-header-cell *matHeaderCellDef>
            {{ "custom-report2.grid.column.minuti_fermata"  | translate }}
          </th>
          <td mat-cell *matCellDef="let row">
            {{ row.minuti_fermata }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  
        <tr class="mat-row w-100" *matNoDataRow>
          <td [attr.colspan]="displayedColumns.length" class="mat-cell mat-cell-no-data text-center">
          </td>
        </tr>
      </table>
    </div>
</div>